import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  folders: [],
};

const folderSlice = createSlice({
  name: 'folders',
  initialState,
  reducers: {
    createFolder: (state, action) => {
      const { parentId, name } = action.payload;
      const newFolder = { id: Date.now().toString(), name, children: [] }; // Benzersiz ID

      if (parentId === null) {
        state.folders.push(newFolder);
      } else {
        const addFolder = (folders) => {
          for (let folder of folders) {
            if (folder.id === parentId) {
              folder.children.push(newFolder);
              return;
            }
            if (folder.children.length > 0) {
              addFolder(folder.children);
            }
          }
        };
        addFolder(state.folders);
      }
    },
  },
});

export const { createFolder } = folderSlice.actions;
export default folderSlice.reducer;